<div class="row col-12 col-sm-12 my-account-container" [ngClass]="isMobile? 'px-0':''">
  @if (!isMobile) {
    <div class="col-3 col-sm-3 my-account-left-nav">
      <app-my-account-left-sidenav [navState]="'MyProfileNavNode'"></app-my-account-left-sidenav>
    </div>
  }
  <div [ngClass]="isMobile? 'col-12 px-0' :'col-9 col-sm-9 my-account-right-nav'">
    <h1 class="myProfileTopHeader m-0">
      {{'common.text_account_closeAccount_header'|cxTranslate}}
    </h1>
    <div class="myProfileBody newmyProfileBody fs-20 closeAccBody">
      <div [innerHTML]="'common.text_account_closeAccount_retention_info'|cxTranslate"></div>
      <div class="btn_div">
        <button (click)="openDialog()" class="btn btn-primary ml-lg-auto mob_width align-items-center">
        {{'common.text_account_close'|cxTranslate}}</button>
      </div>
    </div>
  </div>
</div>